import { animate } from 'motion';

const animatedBlocks = document.querySelectorAll('.animated-block');

animatedBlocks.forEach(container => {
  const animBlocks = container.querySelectorAll('.anim-block');

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animBlocks.forEach((block, i) => {
            const percent = getComputedStyle(block)
              .getPropertyValue('--percent')
              .trim();

            animate(
              block,
              {
                opacity: [0, 1],
                transform: [`translateY(${percent})`, 'translateY(0)'],
              },
              {
                duration: 0.6,
                delay: i * 0.15,
                easing: 'ease-out',
              }
            );
          });

          observer.unobserve(container);
        }
      });
    },
    { threshold: 0.3 }
  );

  observer.observe(container);
});
